import { useEffect, useState } from 'react';
import { useWindowStore } from '../store/windowStore';
import { StartMenu } from './StartMenu';
import { UserMenu } from './UserMenu';

interface TaskbarProps {
  onLaunch: (appId: string) => void;
}

function useClock(): string {
  const [value, setValue] = useState(() => formatNow());
  useEffect(() => {
    const timer = window.setInterval(() => setValue(formatNow()), 30_000);
    return () => window.clearInterval(timer);
  }, []);
  return value;
}

function formatNow(): string {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function Taskbar({ onLaunch }: TaskbarProps) {
  const windows = useWindowStore((s) => s.windows);
  const focusedId = useWindowStore((s) => s.focusedId);
  const focus = useWindowStore((s) => s.focus);
  const minimize = useWindowStore((s) => s.minimize);
  const clock = useClock();

  return (
    <div
      role="toolbar"
      aria-label="taskbar"
      data-testid="taskbar"
      className="os-taskbar"
    >
      <StartMenu onLaunch={onLaunch} />
      <div className="os-taskbar-windows">
        {windows.map((w) => {
          const active = w.id === focusedId && !w.minimized;
          return (
            <button
              key={w.id}
              type="button"
              data-window-id={w.id}
              aria-pressed={active}
              onClick={() => {
                if (active) minimize(w.id);
                else focus(w.id);
              }}
              className={
                'os-taskbar-task' +
                (active ? ' active' : '') +
                (w.minimized ? ' minimized' : '')
              }
            >
              {w.title}
            </button>
          );
        })}
      </div>
      <div className="os-taskbar-tray">
        <UserMenu onOpenProfile={() => onLaunch('profile')} />
        <span className="os-taskbar-clock" aria-label="clock">
          {clock}
        </span>
      </div>
    </div>
  );
}
